class SerializrType_date {
    serializer({ value }) {
        if (value === null || value === undefined)
            return value;
        if (value instanceof Date) {
            return value.mysqlTimestamp;
        }
        console.error('Error in Date serialization, value is no Date object', value);
        return undefined;
    }
    deserializer({ json: dateString }) {
        if (dateString === null || dateString === undefined)
            return dateString;
        return dateString.dateFromMysqlTimestamp;
        // return dateString.dateFromMysqlUTCTimestamp;
    }
}
const obj = new SerializrType_date();
export function date() {
    return obj;
}
